<template>
  <section class="event-jobs">
    <div class="container" v-if="events.length">
      <section-heading
        title="Local Events"
        to="EventList"
        :isViewMore="false"
      ></section-heading>
      <div class="list-horizontal">
        <cs-event-card
          v-for="event in events"
          :key="event.id"
          :title="event.title"
          :picture="event.picture"
          :datetime="event.date_time"
          :location="event.city.name || 'Online'"
          :organiser="event.group.name"
          picture-position="top"
          layout="small"
          hide-buttons
          @click="onOpenEventDetails(event)"
          class="event"
        ></cs-event-card>
      </div>
    </div>
    <div class="container mt-4" v-if="jobs.length">
      <section-heading
        title="Local Jobs"
        to="JobList"
        :isViewMore="false"
      ></section-heading>
      <div class="list-horizontal">
        <div class="job" v-for="job in jobs" :key="job.id">
          <app-job-card :job="job" @click="onOpenJobDetails(job)" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeading from '@/components/general/SectionHeading.vue';
import AppJobCard from '@/components/jobs/JobCard';

export default {
  components: {
    SectionHeading,
    AppJobCard
  },
  props: {
    events: {
      type: Array,
      default() {
        return [];
      },
      required: true
    },
    jobs: {
      type: Array,
      default() {
        return [];
      },
      required: true
    }
  },
  methods: {
    onOpenEventDetails(event) {
      this.$router.push({ name: 'EventDetail', params: { id: event.id } });
    },
    onOpenJobDetails(job) {
      this.$router.push({ name: 'JobDetail', params: { id: job.id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.event-jobs {
  padding-bottom: 20px;
  .list-horizontal {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    width: calc(100% + var(--cs-page-margin-x));
    gap: 20px;
  }
  .list-horizontal > * {
    flex: 0 0 auto;
    width: 320px;
    margin: 20px 0 20px 5px;
  }
  .list-horizontal > .event {
    cursor: pointer;
  }
  .job {
    cursor: pointer;
  }
  @media (max-width: 480px) {
    .list-horizontal > * {
      width: 280px;
    }
  }
}
</style>
